import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toggleVisibility } from 'store/conciergeSlice';
import IconHandler from 'components/common/icon/IconHandler';
import { useLocation } from 'react-router-dom';
import { useHasConciergeDomains } from 'app/concierge/hooks/useHasConciergeDomains';
import { useConciergeVisible } from 'app/concierge/hooks/useConciergeVisible';
import useBundleTranslation from 'i18n';

export default function MenuConcierge() {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const dispatch = useAppDispatch();
    const isConciergeVisible = useConciergeVisible();

    const conciergeSettings = useAppSelector((state) => state.auth?.configuration?.conciergeSettings) ?? {};
    const conciergeSettingDisplay = conciergeSettings.display ?? 'topbar';
    const conciergePanelVisible = useAppSelector((state) => state.concierge.visible);
    const location = useLocation();
    const isPortalPage = location.pathname.includes('/p/');

    const { hasDomains } = useHasConciergeDomains();

    const onClick = () => {
        dispatch(toggleVisibility());
    };

    const iconProps = {
        type: conciergeSettings.bot_icon_ind,
        value:
            conciergeSettings.bot_icon_ind === 'upload'
                ? `data:image/png;base64,${conciergeSettings.bot_icon_data}`
                : conciergeSettings.bot_icon_name,
    };

    if (!(conciergeSettingDisplay === 'topbar' && isConciergeVisible && !conciergePanelVisible && !isPortalPage)) {
        return null;
    }

    return (
        <>
            <Box className={'navbar-menu__root-item-component-icon'}>
                <Tooltip title={hasDomains ? '' : t('no_sources')} placement="bottom">
                    <span>
                        <IconButton
                            onClick={hasDomains ? onClick : undefined}
                            sx={
                                !hasDomains
                                    ? {
                                          opacity: 0.38,
                                          cursor: 'default',
                                          '&:hover': { backgroundColor: 'transparent' },
                                      }
                                    : {}
                            }
                        >
                            <IconHandler icon={iconProps} sx={{ fontSize: '16px' }} />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
            <Box className={'navbar-menu__item-divider'} />
        </>
    );
}
